import React from 'react';
import PropTypes from 'prop-types';

import { FiMinimize2 } from 'react-icons/fi';

import { useReportFullscreen } from './ReportFullscreenContext';
import {
  ReportFullscreenExitButton,
  ReportViewport,
} from './reportsViewStyles';

export default function ReportViewportArea({ children }) {
  const { isReportFullscreen, exitReportFullscreen } = useReportFullscreen();

  return (
    <ReportViewport $isFullscreen={isReportFullscreen}>
      {children}
      {isReportFullscreen && (
        <ReportFullscreenExitButton
          aria-label="Exit full screen"
          title="Exit full screen"
          type="button"
          onClick={exitReportFullscreen}
        >
          <FiMinimize2 size={16} />
        </ReportFullscreenExitButton>
      )}
    </ReportViewport>
  );
}

ReportViewportArea.propTypes = {
  children: PropTypes.node.isRequired,
};
